import { render, staticRenderFns } from "./confirmwithreason.vue?vue&type=template&id=2f598082&"
import script from "./confirmwithreason.vue?vue&type=script&lang=js&"
export * from "./confirmwithreason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports